import { getInitialCountIri } from "containers/Resources/screens/ResourcesSingle/components/RoleIdentityList/constants";
import { actions } from "./IdentityRole.reducer";
import {
    createMutation,
    deleteMutation,
    identityRoleListCountQuery,
    identityRoleListQuery,
    updateMutation,
} from "./IdentityRole.type";

const create = (dispatch, identityId, roleId, propagate) =>
    new Promise((resolve, reject) => {
        dispatch({
            type: actions.START_CREATE_IDENTITYROLE,
            promise: { resolve, reject },
            params: {
                query: createMutation,
                variables: { identityId, roleId, propagate },
            },
        });
    });

const remove = (dispatch, id) =>
    new Promise((resolve, reject) => {
        dispatch({
            type: actions.START_DELETE_IDENTITYROLE,
            promise: { resolve, reject },
            params: {
                query: deleteMutation,
                variables: { id },
            },
        });
    });

const update = (dispatch, id, propagate) =>
    new Promise((resolve, reject) => {
        dispatch({
            type: actions.START_UPDATE_IDENTITYROLE,
            promise: { resolve, reject },
            params: {
                query: updateMutation,
                variables: { id, propagate },
            },
        });
    });

const fetchIdentityList = (dispatch, roleId, variables) =>
    new Promise((resolve, reject) => {
        dispatch({
            type: actions.START_FETCH_IDENTITYROLE_LIST,
            promise: { resolve, reject },
            params: {
                query: identityRoleListQuery,
                variables,
            },
            iri: roleId,
        });
    });

const fetchInitialIdentityListCount = (dispatch, roleId, variables) =>
    new Promise((resolve, reject) => {
        dispatch({
            type: actions.START_FETCH_IDENTITYROLE_LIST_INITIAL_COUNT,
            promise: { resolve, reject },
            params: {
                query: identityRoleListCountQuery,
                variables,
            },
            iri: getInitialCountIri(roleId),
        });
    });

export { create, fetchIdentityList, fetchInitialIdentityListCount, remove, update };
